<template>
  <div class="home-page">
    <!-- Header -->
    <AppHeader />

    <!-- Hero Section -->
    <HeroSection id="home" />

    <!-- Create Section -->
    <section class="create-section">
      <div class="container mx-auto px-4 py-24">
        <h2 class="text-6xl md:text-8xl font-light text-center text-gray-900 tracking-wider">
          {{ $t('home.create.title') }}
        </h2>
      </div>
            <div class="relative min-h-screen overflow-hidden">
        <video
          autoplay
          loop
          muted
          playsinline
          class="w-full h-full object-cover"
        >
          <source src="/videos/videoshow.mp4" type="video/mp4">
        </video>
        <!-- Overlay -->
        <!-- <div class="absolute inset-0 bg-black/20"></div> -->
        <div class="container mx-auto px-4 py-24">
          <div class="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
                <h2 class="text-4xl md:text-6xl font-light text-gray-900 mb-8">
                  {{ $t('home.space.title') }}
                </h2>
                <p class="text-xl text-gray-600 leading-relaxed">
                  {{ $t('home.space.description') }}
                </p>
            </div>
          </div>
        </div>


      </div>
    </section>

    <!-- Space Section
    <section class="space-section bg-white">
      <div class="container mx-auto px-4 py-24">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 class="text-4xl md:text-6xl font-light text-gray-900 mb-8">
              {{ $t('home.space.title') }}
            </h2>
            <p class="text-xl text-gray-600 leading-relaxed">
              {{ $t('home.space.description') }}
            </p>
          </div>
          <div class="text-center">
            <button class="bg-black text-white px-8 py-4 text-lg font-medium hover:bg-gray-800 transition-colors">
              {{ $t('home.space.cta') }}
            </button>
          </div>
        </div>
      </div>
    </section> -->

    <!-- Perfectly Conceived Section -->
    <section class="perfectly-section" style="background-color: #EBEBE9;">
      <div class="container mx-auto px-4 py-24">
        <h2 class="text-4xl md:text-6xl font-light text-center text-gray-900 mb-16">
          {{ $t('home.perfectly.title') }}
        </h2>

        <!-- Three column grid layout -->
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <!-- Design meets technology -->
          <div class="perfect-card bg-white rounded-lg shadow-sm overflow-hidden">
            <img src="/images/design-technology.jpg" alt="Design meets technology" class="w-full h-64 object-cover">
            <div class="p-6">
              <div class="mb-2">
                <h3 class="text-lg font-medium text-gray-900">{{ $t('home.design.title') }}</h3>
              </div>
              <div class="text-sm text-gray-600">{{ $t('home.design.description') }}</div>
            </div>
          </div>

          <!-- Durable & classy -->
          <div class="perfect-card bg-white rounded-lg shadow-sm overflow-hidden">
            <img src="/images/durable-classy.jpg" alt="Durable & classy" class="w-full h-64 object-cover">
            <div class="p-6">
              <div class="mb-2">
                <h3 class="text-lg font-medium text-gray-900">{{ $t('home.durable.title') }}</h3>
              </div>
              <div class="text-sm text-gray-600">{{ $t('home.durable.description') }}</div>
            </div>
          </div>

          <!-- Automatic & intelligent -->
          <div class="perfect-card bg-white rounded-lg shadow-sm overflow-hidden">
            <img src="/images/automatic-intelligent.jpg" alt="Automatic & intelligent" class="w-full h-64 object-cover">
            <div class="p-6">
              <div class="mb-2">
                <h3 class="text-lg font-medium text-gray-900">{{ $t('home.automatic.title') }}</h3>
              </div>
              <div class="text-sm text-gray-600">{{ $t('home.automatic.description') }}</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Wherever Section -->
    <section id="wherever" class="wherever-section bg-white">
      <div class="container mx-auto px-4 py-24">
        <div class="section-head is-vertical">
          <div class="max-width-large">
            <h2 class="heading-style-h2">{{ $t('home.wherever.title') }}</h2>
          </div>
          <div class="slider-1_pagination swiper-pagination-clickable swiper-pagination-bullets swiper-pagination-horizontal"></div>
        </div>
        <div class="swiper swiper-slider-1 w-dyn-list">
          <div role="list" class="swiper-wrapper w-dyn-items">
            <div v-for="category in applicationCategories" :key="category.key" :slide-name="category.title" role="group" class="swiper-slide w-dyn-item">
              <div class="slider-1_slide">
                <img :src="category.image" :alt="category.title" class="slider-1_image">
                <div class="slider-1_content">
                  <div>
                    <div class="margin-bottom margin-xxsmall">
                      <h3 class="text-size-regular">{{ category.title }}</h3>
                    </div>
    
                  </div>
    
                </div>
              </div>
            </div>
          </div>
          <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
        </div>
      </div>
    </section>

    <!-- Projects Section -->
    <ProjectsSection id="projects" />

    <!-- Quality Section -->
    <section class="quality-section bg-gray-50">
      <div class="container mx-auto px-4 py-24">
        <h2 class="text-4xl md:text-6xl font-light text-center text-gray-900 mb-16">
          {{ $t('home.quality.title') }}
        </h2>

        <!-- Quality tabs -->
        <div class="grid grid-cols-1 lg:grid-cols-4 gap-8">
          <div v-for="tab in qualityTabs" :key="tab.key" class="text-center">
            <div class="bg-white p-8 rounded-lg shadow-sm">
              <img :src="tab.icon" :alt="tab.title" class="w-16 h-16 mx-auto mb-4">
              <h4 class="text-xl font-medium text-gray-900 mb-4">{{ tab.title }}</h4>
              <p class="text-gray-600">{{ tab.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Company Section -->
    <section class="company-section bg-white">
      <div class="container mx-auto px-4 py-24">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 class="text-4xl font-light text-gray-900 mb-8">{{ $t('home.company.title') }}</h2>
            <p class="text-xl text-gray-600 leading-relaxed mb-8">{{ $t('home.company.description') }}</p>

          </div>
          <div>
            <img src="/images/company.jpg" alt="Company" class="w-full h-96 object-cover rounded-lg">
          </div>
        </div>
      </div>
    </section>

    <!-- News Section -->
    <section class="news-section bg-gray-50">
      <div class="container mx-auto px-4 py-24">
        <h2 class="text-4xl font-light text-center text-gray-900 mb-16">{{ $t('home.news.title') }}</h2>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div v-for="news in latestNews" :key="news.id" class="bg-white rounded-lg shadow-sm overflow-hidden">
            <img :src="news.image" :alt="news.title" class="w-full h-48 object-cover">
            <div class="p-6">
              <h3 class="text-xl font-medium text-gray-900 mb-2">{{ news.title }}</h3>
              <p class="text-gray-600 mb-4">{{ news.excerpt }}</p>
              <span class="text-sm text-gray-500">{{ news.date }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Accessories Section -->
    <section class="accessories-section bg-white">
      <div class="container mx-auto px-4 py-24">
        <h2 class="text-4xl font-light text-center text-gray-900 mb-16">{{ $t('home.accessories.title') }}</h2>
        <p class="text-xl text-gray-600 text-center max-w-3xl mx-auto mb-12">{{ $t('home.accessories.description') }}</p>
        <div class="text-center">
          <a href="https://shopee.tw/lch3365.work" target="_blank" rel="noopener noreferrer">
            <img src="https://upload.wikimedia.org/wikipedia/commons/f/fe/Shopee.svg" alt="Shopee" class="inline-block h-16 hover:opacity-80 transition-opacity cursor-pointer">
          </a>
        </div>
      </div>
    </section>

    <!-- Project CTA Section -->
    <section class="project-cta-section bg-black text-white">
      <div class="container mx-auto px-4 py-24 text-center">
        <h2 class="text-4xl md:text-6xl font-light mb-8">{{ $t('home.projectCta.title') }}</h2>
        <button class="bg-white text-black px-8 py-4 text-lg font-medium hover:bg-gray-100 transition-colors">
          {{ $t('home.projectCta.cta') }}
        </button>
      </div>
    </section>

    <!-- Contact Section -->
    <ContactSection id="contact" />

    <!-- Footer -->
    <AppFooter />
  </div>
</template>

<script>
import { defineAsyncComponent, onMounted, nextTick, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import Swiper from 'swiper'
import { Autoplay, Pagination } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/autoplay'
import 'swiper/css/pagination'
import { API_BASE_URL, API_ENDPOINTS, buildApiUrl } from '@/config/api.js'

// Import all sections
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'
import HeroSection from '@/components/sections/HeroSection.vue'
import ProjectsSection from '@/components/sections/ProjectsSection.vue'
import ContactSection from '@/components/sections/ContactSection.vue'

export default {
  name: 'Home',
  components: {
    AppHeader,
    AppFooter,
    HeroSection,
    ProjectsSection,
    ContactSection
  },
  setup() {
    const { t, locale } = useI18n()

    // Add page-specific meta data
    document.title = '閎凱綠能遮陽工程 - 專業遮陽系統工程'
    document.querySelector('meta[name="description"]')?.setAttribute('content', '逐光而行，構築遮陽的美學秩序。以結構的力量與設計的比例，為每一道光與風，找到最穩定的平衡。')

    // Application categories data - now reactive and loaded from API
    const applicationCategories = ref([])

    // Load categories from API
    const loadCategories = async () => {
      try {
        const response = await fetch(buildApiUrl(API_ENDPOINTS.CATEGORIES + `?locale=${locale.value}`))
        const data = await response.json()
        if (data.success) {
          applicationCategories.value = data.data
        } else {
          // Fallback to default categories if API fails
          console.warn('Failed to load categories from API, using defaults')
          applicationCategories.value = [
            {
              key: 'specials',
              title: t('home.categories.specials'),
              image: '/images/categories/specials.jpg'
            },
            {
              key: 'public-spaces',
              title: t('home.categories.publicSpaces'),
              image: '/images/categories/public-spaces.jpg'
            },
            {
              key: 'education-care',
              title: t('home.categories.educationCare'),
              image: '/images/categories/education-care.jpg'
            },
            {
              key: 'around-water',
              title: t('home.categories.aroundWater'),
              image: '/images/categories/around-water.jpg'
            },
            {
              key: 'garden',
              title: t('home.categories.garden'),
              image: '/images/categories/garden.jpg'
            },
            {
              key: 'balcony',
              title: t('home.categories.balcony'),
              image: '/images/categories/balcony.jpg'
            },
            {
              key: 'hotels-restaurants',
              title: t('home.categories.hotelsRestaurants'),
              image: '/images/categories/hotels-restaurants.jpg'
            },
            {
              key: 'terrace',
              title: t('home.categories.terrace'),
              image: '/images/categories/terrace.jpg'
            },
            {
              key: 'rooftop-terrace',
              title: t('home.categories.rooftopTerrace'),
              image: '/images/categories/rooftop-terrace.jpg'
            }
          ]
        }
      } catch (error) {
        console.error('Error loading categories:', error)
        // Fallback to default categories
        applicationCategories.value = [
          {
            key: 'specials',
            title: t('home.categories.specials'),
            image: '/images/categories/specials.jpg'
          },
          {
            key: 'public-spaces',
            title: t('home.categories.publicSpaces'),
            image: '/images/categories/public-spaces.jpg'
          },
          {
            key: 'education-care',
            title: t('home.categories.educationCare'),
            image: '/images/categories/education-care.jpg'
          },
          {
            key: 'around-water',
            title: t('home.categories.aroundWater'),
            image: '/images/categories/around-water.jpg'
          },
          {
            key: 'garden',
            title: t('home.categories.garden'),
            image: '/images/categories/garden.jpg'
          },
          {
            key: 'balcony',
            title: t('home.categories.balcony'),
            image: '/images/categories/balcony.jpg'
          },
          {
            key: 'hotels-restaurants',
            title: t('home.categories.hotelsRestaurants'),
            image: '/images/categories/hotels-restaurants.jpg'
          },
          {
            key: 'terrace',
            title: t('home.categories.terrace'),
            image: '/images/categories/terrace.jpg'
          },
          {
            key: 'rooftop-terrace',
            title: t('home.categories.rooftopTerrace'),
            image: '/images/categories/rooftop-terrace.jpg'
          }
        ]
      }
    }

    // Initialize Swiper function
    const initSwiper = () => {
      // Destroy existing swiper if exists
      const existingSwiper = document.querySelector('.swiper-slider-1')?.swiper
      if (existingSwiper) {
        existingSwiper.destroy()
      }

      // Initialize new swiper
      new Swiper('.swiper-slider-1', {
        modules: [Autoplay, Pagination],
        direction: 'horizontal',
        loop: applicationCategories.value.length > 1,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.slider-1_pagination',
          clickable: true,
          renderBullet: (index, className) => {
            return `<span class="${className}"></span>`
          },
        },
      })
    }

    onMounted(async () => {
      // Load categories first
      await loadCategories()

      // Wait for DOM update and initialize Swiper
      await nextTick()
      setTimeout(initSwiper, 200)
    })

    // Watch for categories changes and reinitialize swiper
    watch(applicationCategories, async (newCategories) => {
      if (newCategories && newCategories.length > 0) {
        await nextTick()
        setTimeout(initSwiper, 200)
      }
    }, { deep: true })

    // Quality tabs data
    const qualityTabs = [
      {
        key: 'made-in-taiwan',
        title: t('home.qualityTabs.madeInTaiwan.title'),
        description: t('home.qualityTabs.madeInTaiwan.description'),
        icon: '/images/icons/made-in-taiwan.png'
      },
      {
        key: 'certified-patented',
        title: t('home.qualityTabs.certifiedPatented.title'),
        description: t('home.qualityTabs.certifiedPatented.description'),
        icon: '/images/icons/certified.svg'
      },
      {
        key: 'easy-installation',
        title: t('home.qualityTabs.easyInstallation.title'),
        description: t('home.qualityTabs.easyInstallation.description'),
        icon: '/images/icons/installation.png'
      },
      {
        key: 'trained-partners',
        title: t('home.qualityTabs.trainedPartners.title'),
        description: t('home.qualityTabs.trainedPartners.description'),
        icon: '/images/icons/partners.svg'
      }
    ]

    // Latest news data
    const latestNews = [
      {
        id: 1,
        title: t('home.latestNews.galaBau.title'),
        excerpt: t('home.latestNews.galaBau.excerpt'),
        image: '/images/news/gala-bau.jpg',
        date: '15.09.2026'
      },
      {
        id: 2,
        title: t('home.latestNews.callweyAward.title'),
        excerpt: t('home.latestNews.callweyAward.excerpt'),
        image: '/images/news/callwey-award.jpg',
        date: '26.02.2026'
      },
      {
        id: 3,
        title: t('home.latestNews.meesters.title'),
        excerpt: t('home.latestNews.meesters.excerpt'),
        image: '/images/news/meesters.jpg',
        date: '02.10.2025'
      }
    ]

    // Scroll to section function
    const scrollToSection = (sectionId) => {
      const element = document.getElementById(sectionId)
      if (element) {
        const headerHeight = 80
        const elementPosition = element.offsetTop - headerHeight

        window.scrollTo({
          top: elementPosition,
          behavior: 'smooth'
        })
      }
    }

    return {
      applicationCategories,
      qualityTabs,
      latestNews
    }
  }
}
</script>

<style scoped>
/* Home page specific styles */
.home-page {
  /* Ensure smooth scrolling to sections */
  scroll-behavior: smooth;
}

/* Add subtle animations on scroll */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.section-enter {
  animation: fadeInUp 0.8s ease-out;
}

/* Responsive spacing adjustments */
@media (max-width: 768px) {
  .home-page > section {
    margin-bottom: 2rem;
  }
}

/* Swiper styles for wherever section */
.section-head.is-vertical {
  text-align: center;
  margin-bottom: 3rem;
  position: relative;
  z-index: 10;
}

.max-width-large {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

.heading-style-h2 {
  font-size: 2.5rem;
  font-weight: 300;
  margin-bottom: 2rem;
}

.slider-1_pagination {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 2rem;
  background: white;
  position: relative;
  z-index: 10;
}

.slider-1_pagination .swiper-pagination-bullet {
  width: 10px;
  height: 10px;
  background: #d1d5db;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s;
  opacity: 1;
}

.slider-1_pagination .swiper-pagination-bullet:hover {
  background: #9ca3af;
  transform: scale(1.2);
}

.slider-1_pagination .swiper-pagination-bullet-active {
  background: #000;
  transform: scale(1.3);
}

.swiper-slider-1 {
  width: 100%;
  height: auto;
  margin-top: 2rem;
  position: relative;
  z-index: 1;
}

.slider-1_slide {
  position: relative;
  width: 100%;
  height: 500px;
  overflow: hidden;
}

.slider-1_image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.slider-1_content {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 0.7) 50%, transparent 100%);
  padding: 3rem 2rem 2rem 2rem;
  color: white;
  z-index: 2;
}

.margin-bottom.margin-xxsmall {
  margin-bottom: 0.5rem;
}

.text-size-regular {
  font-size: 1.125rem;
  font-weight: 500;
}

.text-size-small {
  font-size: 0.875rem;
  opacity: 0.9;
}

.button {
  display: inline-block;
  padding: 0.75rem 1.5rem;
  background: white;
  color: black;
  text-decoration: none;
  font-weight: 500;
  transition: background 0.3s;
}

.button:hover {
  background: #f0f0f0;
}
</style>
